export default "__VITE_ASSET__giFjT4H$__"